import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SFutureMessageInspiration = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 3rem 0 2rem;
`

export const SFutureMessageInspirationHeader = styled.div<{ isMore?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: ${({ isMore }) => (isMore ? 'center' : 'flex-end')};
  margin-bottom: 2rem;

  @media ${BREAKPOINTS.LG.max} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const SIconButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: var(--card-shadow);
  width: ${pxToRem(36)}rem;
  height: ${pxToRem(36)}rem;
  color: var(--c-blue500);
  aspect-ratio: 1;
  background-color: white;
`
